<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    
    <v-card v-if="feesdata != null">
      <v-card-text>
        <v-row justify="center">
          <v-col sm="3">
            <h3>Application Form Fees Payment</h3>
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col sm="2">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              required
              readonly
              label="Form No"
              name="form_no"
              v-model="feesdata.display_admission_form_no"
              filled
              outlined
            />
          </v-col>
          <v-col sm="8">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              required
              readonly
              label="Student Full Name"
              name="stud_name"
              v-model="feesdata.stud_name"
              filled
              outlined
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense> </v-row>
        <v-row justify="center" dense>
          <v-col sm="5">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              required
              readonly
              label="Admission Year"
              name="ay"
              v-model="feesdata.ay"
              filled
              outlined
            />
          </v-col>
          <v-col sm="5">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              required
              readonly
              label="Amount"
              name="amount"
              v-model="feesdata.form_amount"
              filled
              outlined
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="3">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-combobox
              dense
              v-model="form_fees.bank"
              :items="bank_list"
              item-text="Bank"
              label="Bank"
              outlined
            ></v-combobox>
            <!-- <v-text-field dense label="Bank Name" name="bank_name" outlined /> -->
          </v-col>
          <v-col sm="2">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-combobox
              dense
              v-model="form_fees.payment_mode"
              :items="mode_list"
              item-text="Payment Mode"
              label="*Payment Mode"
              outlined
            ></v-combobox>
          </v-col>

          <v-col sm="1">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              label="Amount"
              v-model="form_fees.amount"
              outlined
            />
          </v-col>
          <v-col sm="2">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  v-model="form_fees.drawn_on_date"
                  name="drawn_on_date"
                  label="Drawn On Date"
                  @blur="date = parseDate(form_fees.drawn_on_date)"
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col sm="2">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              label="Transaction No"
              v-model="form_fees.trans_id"
              outlined
            />
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col sm="10">
            <!-- <v-icon color="error">*</v-icon> -->
            <v-text-field
              dense
              label="Remark"
              name="remark"
              v-model="form_fees.remark"
              outlined
            />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="1">
            <v-btn
              color="primary darken-1"
              @click="payFormFees"
              :loading="pay_btn_load"
              >Proceed</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    application_form_data: null,
    feesdata: null,
    mode_list: null,
    bank_list: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    //form_fees
    form_fees: {
      form_id: null,
      form_fees_master_id: null,
      bank: null,
      payment_mode: null,
      amount: 0,
      drawn_on_date: null,
      trans_id: 0,
      remark: null
    },
    pay_btn_load: false
  }),
  methods: {
    payFormFees() {
      this.pay_btn_load = true;
      axios
        .post("/account/payFormFees", this.form_fees)
        .then(res => {
          if (res.data.msg == "200") {
            if (res.data.status == "NO") {
              alert(res.data.status_reason);

              return;
            } else {
              this.$store.commit("setform_fees_trans_id", res.data.afft_id);
              this.$router.push({ name: "form-fees-receipt" });
              return
            }
          } else {
            //error
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.pay_btn_load = false;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
  },
  mounted() {
    this.application_form_data = this.$store.getters.application_form_data;
    if (this.application_form_data.admission_form_id == "") {
      this.$router.push({ name: "application-form" });
    }
    axios
      .post("/account/getStaffFormFees", this.application_form_data)
      .then(res => {
        if (res.data.msg == "200") {
          if (res.data.status == "NO") {
            this.$store.commit("setform_fees_trans_id", res.data.afft_id);
            // alert(res.data.status_reason+res.data.afft_id);
            this.$router.push({ name: "form-fees-receipt" });
            this.showSnackbar("error", res.data.status_reason)
            return;
          } else {
            this.feesdata = res.data.feesdata;
            this.mode_list = res.data.mode_list;
            this.bank_list = res.data.bank_list;
            this.form_fees.amount = this.feesdata.form_amount;
            this.form_fees.payment_mode = this.mode_list[0];
            this.form_fees.form_id = this.feesdata.form_id;
            this.form_fees.form_fees_master_id = this.feesdata.form_fees_master_id;
          }
        } else {
          //error
        }
      })
      .catch(error => {
        window.console.log(error);
      })
      .finally(() => {
        //close loader
      }); 
  },
  watch: {
    date(val) {
      this.form_fees.drawn_on_date = this.formatDate(this.date);
    }
  }
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
</style>
